
import {
	SUBMIT_ORDER_REQUEST,
	SUBMIT_ORDER_SUCCESS,
	SUBMIT_ORDER_FAILURE,
	INITIATE_PAYMENT_REQUEST,
	INITIATE_PAYMENT_SUCCESS,
	INITIATE_PAYMENT_FAILURE
} from './choose-menu-types';

export const submitOrderRequest = (orderData) => ({
	type: SUBMIT_ORDER_REQUEST,
	payload: orderData
});

export const submitOrderSuccess = (response) => ({
	type: SUBMIT_ORDER_SUCCESS,
	payload: response
});

export const submitOrderFailure = (error) => ({
	type: SUBMIT_ORDER_FAILURE,
	payload: error
});

// Payment initiation actions
export const initiatePaymentRequest = (paymentData) => ({
	type: INITIATE_PAYMENT_REQUEST,
	payload: paymentData
});

export const initiatePaymentSuccess = (response) => ({
	type: INITIATE_PAYMENT_SUCCESS,
	payload: response
});

export const initiatePaymentFailure = (error) => ({
	type: INITIATE_PAYMENT_FAILURE,
	payload: error
});
